import { SET_ERROR } from '../actionTypes'

export default function errorAction(message){

    return { type: SET_ERROR, payload: message }
}